import { render, staticRenderFns } from "./Asbook.vue?vue&type=template&id=2bb724da&scoped=true"
import script from "./Asbook.vue?vue&type=script&lang=js"
export * from "./Asbook.vue?vue&type=script&lang=js"
import style0 from "./Asbook.vue?vue&type=style&index=0&id=2bb724da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb724da",
  null
  
)

export default component.exports